import * as React from 'react'

import './ScoreViewStyles.scss';

const ScoreView = (props:any) => {

    let periodScore:any;

    const scores:any = Object.keys(props.periodScores).map((key:any) => {
        periodScore = props.periodScores[key];

        // key reflects the set - we only want numbers from 1-5 to cause a score column but no other properties
        if (key > 0 && key < 6) {
            return (
                <div key={ `${props.homeOrAway}-${key}` } className={
        isSetWinner( periodScore.winner, props.homeOrAway ) + isActiveSet( props.period, key )}>
                    { renderPeriodScore( parseInt(key), props.period, periodScore, props.homeOrAway ) }
                </div>
            )
        } else {
            return ('');
        }
    })

    // render current game score
    return (
        <div className="livescoreScores">
            { scores }
            <div className='livescoreGameScore'>
                {props.gamePoints[ props.homeOrAway ]}
            </div>
        </div>
    )
}

const renderPeriodScore = (period:number, activePeriod:number, periodScore:any, homeOrAway:string) => {
    let score:any

    // use this again when the "setBegins" event is available and everything is back to normal
    //period <= activePeriod ? score = periodScore[homeOrAway] || 0 : score = '-';

    // ----------------------------------------  remove this when the "setBegins" event is available -----------
    if(period <= activePeriod) {
        if(periodScore[homeOrAway]) { score = periodScore[homeOrAway]; }
        else { score = 0; }
    }
    else {
        if (periodScore[homeOrAway] != null){ score = periodScore[homeOrAway];}
        else { score = '-'; }
    }
    // ----------------------------------------  remove this when the "setBegins" event is available -----------

    return score
}

// sets css class to hide something
const isHidden = (value:boolean) => value ? 'hidden' : ''

// set class to mark set winner
const isSetWinner = (winner:string, value:string) => {
    return winner == value ? 'setWinner' : '';
}

// set class to mark currently played set
const isActiveSet = (currentSet:number, key:number) => {
    return currentSet == key ? ' currentlyRunningSet' : '';
}

export default ScoreView
